
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Database } from '@/integrations/supabase/types';
import { reportError } from '@/utils/errorReporter';
import { getTimeoutSignal, retryOnTransientNetwork } from '@/utils/networkResilience';

export type SiteSettings = Database['public']['Tables']['site_settings']['Row'];

const fetchSiteSettings = async (): Promise<SiteSettings | null> => {
    return retryOnTransientNetwork(async () => {
        const { signal, clear } = getTimeoutSignal();
        
        try {
            const query = supabase
                .from('site_settings')
                .select('*')
                .eq('id', 1)
                .maybeSingle();

            // @ts-ignore - abortSignal exists at runtime in supabase-js v2
            const { data, error } = await (query.abortSignal ? query.abortSignal(signal) : query);

            clear();
            
            if (error) {
                console.error('Error fetching site settings:', error);
                return null;
            }
            return data;
        } catch (e) {
            clear();
            console.error('Site settings request timed out or failed:', e);
            reportError('Homepage/SiteSettings', e);
            throw e;
        }
    });
};

export const useSiteSettings = () => {
    return useQuery<SiteSettings | null>({
        queryKey: ['site-settings'],
        queryFn: fetchSiteSettings,
    });
};
